module.exports = __webpack_public_path__ + "static/baby-yoda-0eba1ef310cbc3f2f99ab7bbceec0075.jpg";